import './homeCardStyle.css'

export type Props={
    tabIndex?:number;
    cardTitle:string;
    cardDesc?:string;
    cardImage:JSX.Element | JSX.Element[];
    cardStyle?: any;
    cardEvent?:()=>void;
}

const HomeCardComponent:React.FC<Props>=({cardTitle, cardDesc, cardImage, cardEvent, tabIndex, cardStyle})=>{

return(<div 
        id={cardTitle} 
        role="button" 
        className="home-card" 
        tabIndex={tabIndex} 
        style={cardStyle}
        onClick={()=>{if(cardEvent){cardEvent()}}}
        onKeyUp={(event)=>{if(cardEvent && event.key === "Enter") { cardEvent() }}}
    >
    <h2>{cardTitle}</h2>
    {cardDesc &&
    <h3>{cardDesc}</h3>
    }
    <div className='image-container'>
    {cardImage}
    </div>
</div>)

}

export default HomeCardComponent